/* ==========================================================================
   BOUNTEOUS CONFIDENTIAL
   ___________________

   Copyright 2019 Bounteous
   All Rights Reserved.

   NOTICE:  All information contained herein is, and remains the property
   of Bounteous and its suppliers, if any. The intellectual and
   technical concepts contained herein are proprietary to Bounteous
   and its suppliers and are protected by trade secret or copyright law.
   Dissemination of this information or reproduction of this material
   is strictly forbidden unless prior written permission is obtained
   from Bounteous.
   ========================================================================== */

import { Component, registerComponent } from 'js/component.js';
import { buildQueryString } from 'js/helpers.js';

const componentName = 'cmp-search-box';

class Searchbox extends Component {

    /**
     * Close Search
     */
    closeSearch() {
        this.elements.form.classList.remove('open');
        this.isOpen = false;
    }

    /**
     * Open Search
     */
    openSearch() {
        this.elements.form.classList.add('open');
        this.isOpen = true;
        this.elements.input.focus();
    }

    /**
     * Add Event Listeners
     */
    addEventListeners() {
        const classScope = this;

        // Click search button (open/close/submit logic)
        function clickSearchIcon(e) {
            if(classScope.isOpen) {
                if(classScope.term !== '') {
                    classScope.closeSearch();
                    return true;
                }
                e.preventDefault();
                classScope.closeSearch();
            } else {
                e.preventDefault();
                classScope.openSearch();
            }
            return false;
        }

        // Click document to close search bar
        function clickOutside(e) {
            if (!classScope.elements.form.contains(e.target)) {
                classScope.closeSearch();
            }
        }

        // Update search term
        function updateSearchTerm() {
            const { value } = classScope.elements.input;
            classScope.term = value;
        }

        // Submit Search
        function submitSearch(e) {
            e.preventDefault();
            const hashParams = `#${buildQueryString({ q: classScope.term, page: '1' })}`;
            const newLocation = `${classScope.formAction}${hashParams}`;

            window.location = newLocation;
        }

        // Add Listeners
        this.elements.input.addEventListener('keyup', updateSearchTerm);
        this.elements.button.addEventListener('click', clickSearchIcon);
        this.elements.form.addEventListener('submit', submitSearch);
        document.addEventListener('click', clickOutside);
    }

    /**
     * Initialize Component
     */
    init() {
        // Set Up Elements
        this.elements = {
            form: this.element.querySelector(`.${componentName}__form`),
            input: this.element.querySelector(`.${componentName}__input`),
            button: this.element.querySelector(`.${componentName}__button`),
        };

        // Set Up Data
        this.term = '';
        this.isOpen = false;
        this.formAction = this.elements.form.getAttribute('action');

        // Fire Init Funcs
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, Searchbox);
